import React, { useState } from "react";
import { Input } from "../../components/ui/input-field";
import logo2 from "../../assets/images/80eight/88-blue.svg";
import forgetEmail from "../../assets/images/forgetEmail.png";
import Toaster from "../../components/ui/toaster";
import { useToast } from "../../hooks/use-toast";
import { api } from "../../services/axiosService";
import { Link } from "react-router-dom";

export default function ForgetEmail() {
  const { toast } = useToast();
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const validateForm = () => {
    const newErrors = {};

    if (!email) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = "Enter a valid email address";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setIsLoading(true);
    try {
      const response = await api.post("/api/v1/user/forgot-password", {
        email,
      });

      if (response.data?.status) {
        toast({
          description: "Password reset link sent successfully!",
          variant: "success",
        });
        setIsSuccess(true);
        setEmail("");
      } else {
        toast({
          description: response.data?.message || "Failed to send reset link",
          variant: "error",
        });
      }
    } catch (error) {
      console.error("Forgot password error:", error);
      toast({
        description: error,
        variant: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen text-gray-900 transition-colors dark:text-gray-100">
      <div className="flex border-0 justify-between items-center pt-[3.75rem] pb-[1.75rem] lg:pt-[2rem] lg:px-16 px-5 lg:pb-[1.8rem] lg:border lg:border-b lg:border-b-[#EBE9EF]">
        <Link to="/">
          <img src={logo2} alt="80eight Logo" className="w-[120px] h-auto" />
        </Link>
      </div>
      <div className="h-[4px] bg-gray-200 rounded-full w-full lg:hidden block"></div>

      <form
        onSubmit={handleSubmit}
        className="z-10 mt-[1.5rem] flex flex-col items-center justify-center min-h-[70vh] max-w-[628px] mx-auto lg:px-0 px-5"
      >
        <div className="lg:mt-[50px] mt-[40px]">
          <img
            src={forgetEmail}
            alt="Forget Email Illustration"
            className="mx-auto w-[194px] h-[136px]"
          />
          \
        </div>

        <p className="font-plusjakarta font-semibold text-[32px] leading-[40px] tracking-normal text-center text-[#57249C] mt-2 mb-12">
          Enter your email
        </p>

        <Input
          type="email"
          text="What is your email address?"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
            if (errors.email) {
              setErrors({ ...errors, email: "" });
            }
          }}
          state={errors.email ? "error" : "default"}
          helperText={errors.email || ""}
          className="!py-[27px] border-[1px] text-[16px] font-plusjakarta"
        />

        <p className="max-w-[460px] text-center text-gray-600 text-[16px] my-8">
          We will send you a password reset link to your email address. Click on
          the link and follow the instructions.
        </p>

        <button
          type="submit"
          className={`
            ${
              !isLoading && email && !isSuccess
                ? "bg-[linear-gradient(86.72deg,#57249C_-10.66%,#EB3366_113.47%)] text-white hover:scale-[1.02]"
                : "bg-[#F2F1F4] cursor-not-allowed text-[#9D96AF]"
            }
            flex items-center justify-center font-semibold text-[20px] font-[400] lg:mb-10 mb-5 px-8 lg:py-[17px] py-[12px] rounded-full w-full transition duration-300 ease-in-out
          `}
          disabled={isLoading || !email || isSuccess}
        >
          {isLoading ? (
            <>
              <svg
                className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
              </svg>
              Sending...
            </>
          ) : (
            "Send Link"
          )}
        </button>
      </form>
      <Toaster />
    </div>
  );
}
